import React, { FunctionComponent, ReactNode } from 'react';
import * as Styled from './styled';

export interface PageWrapperProps {
  paddingBottom?: number | null;
  children: ReactNode;
}

const PageWrapper: FunctionComponent<PageWrapperProps> = ({ paddingBottom, children }) => {
  return <Styled.PageWrapper $paddingBottom={paddingBottom}>{children}</Styled.PageWrapper>;
};

export default PageWrapper;
